import { render, staticRenderFns } from "./setOrderEdit.vue?vue&type=template&id=4c4e6469&scoped=true&"
import script from "./setOrderEdit.vue?vue&type=script&lang=js&"
export * from "./setOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./setOrderEdit.vue?vue&type=style&index=0&id=4c4e6469&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e6469",
  null
  
)

export default component.exports